import { render } from "./ConnectionsWithRegions.vue?vue&type=template&id=1efa17c2&scoped=true"
import script from "./ConnectionsWithRegions.vue?vue&type=script&lang=js"
export * from "./ConnectionsWithRegions.vue?vue&type=script&lang=js"

import "./ConnectionsWithRegions.vue?vue&type=style&index=0&id=1efa17c2&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1efa17c2"]])

export default __exports__